import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/enterpriseProjects/messages";
import { camelizeKeys } from "@helpers";

function* getLeadOfferResponseDetails(action) {
  const { id } = action.payload;
  const { success, data, error } = yield* makeRequest.get(`/offer_responses/${id}`, {});

  if (success && data) {
    yield put(actions.setLeadOfferResponseDetails(camelizeKeys(data.body)));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_ENTERPRISE_LEAD_OFFER_RESPONSE,
    });
  }

  return null;
}

export default getLeadOfferResponseDetails;
